import * as styles from "./styles.css";
import { cn } from "@discovery/classnames";
import { Icon, Icons } from "../../icon";
import Strings from "../../../../utils/hardcoded.json";
import { updateGlobalState } from "@discovery/common-dplus/lib/hooks";
import { Lens } from "@discovery/prelude/lib/control/lens";
export const Modal = ({ children, label, showErrorMsg, style, hideHeader, errorMsg, showErrorMsgForNewPinMatchCurrentPin, currentPinMatchesNewPin, }) => {
    const setShowAllAccess = (accessState) => updateGlobalState(Lens.prop("isParentalLockAccess"))((_isParentalLockAccess) => accessState);
    const onBack = () => {
        window.history.back();
        setShowAllAccess(false);
    };
    return (React.createElement("div", { className: styles.modalOverlay, onClick: (event) => {
            event.stopPropagation();
        } },
        React.createElement("div", { className: cn(styles.card, style) },
            React.createElement("div", { className: styles.innerWrapper },
                !hideHeader ? (React.createElement("div", { className: styles.header },
                    React.createElement("div", { className: styles.goBack, onClick: onBack },
                        React.createElement(Icon, { type: Icons.LeftArrow, className: styles.backArrow, color: "white" })),
                    React.createElement("div", { className: styles.title }, label))) : (React.createElement("div", null)),
                children),
            showErrorMsg && (React.createElement("div", { className: styles.errorMsgWrapper },
                React.createElement(Icon, { type: Icons.PinMisMacth, className: styles.errorImage }),
                React.createElement("div", { className: styles.errorCode }, errorMsg))),
            currentPinMatchesNewPin && (React.createElement("div", { className: styles.errorMsgWrapper },
                React.createElement(Icon, { type: Icons.PinMisMacth, className: styles.errorImage }),
                React.createElement("div", { className: styles.errorCode }, Strings.ALREADY_USED_PIN))),
            showErrorMsgForNewPinMatchCurrentPin && (React.createElement("div", { className: styles.errorMsgWrapper },
                React.createElement(Icon, { type: Icons.PinMisMacth, className: styles.errorImage }),
                React.createElement("div", { className: styles.errorCode }, Strings.NEW_PIN_MISMATCH))))));
};

